import { alphaNumericWithSpecialCharactersValidator, numberValidator, formElement, getDate, getFileType } from 'home/view/upgrade-order/utils';

export const purchaseOrderExpiryDateKey = 'purchaseOrderExpiryDate';

export const formSchema = {
  purchaseOrderNo: {
    ...formElement,
    validator: alphaNumericWithSpecialCharactersValidator
  },
  purchaseOrderDate: { ...formElement },
  [purchaseOrderExpiryDateKey]: { ...formElement },
  purchaseOrderTotalCharges: { ...formElement, validator: numberValidator },
  files: { ...formElement }
};

export const ignoreKeys = ['touched', purchaseOrderExpiryDateKey];

export const getDefaultFiles = (uploadedDocs) => {
  if (uploadedDocs && uploadedDocs.PURCHASE_ORDER) {
    const documents = uploadedDocs.PURCHASE_ORDER;
    return Object.keys(documents).reduce((accumulator, documentName) => {
      const splittedValue = (documents[documentName] && documents[documentName].split('purchase_order/')[1]) || '';
      const name = splittedValue || `document${documentName}`;
      const fileType = splittedValue.split('.')[1];
      const type = getFileType(fileType) && getFileType(fileType).type;

      return accumulator.concat({ name, size: 100, documentName, type });
    }, []);
  }
  return [];
};

export const getDefaultValue = (order) => {
  const poAmount = order && order.purchaseOrder && order.purchaseOrder.poAmount;
  const poNumber = order && order.purchaseOrder && order.purchaseOrder.poNumber;
  const purchaseOrderDate = order && order.purchaseOrder && order.purchaseOrder.purchaseOrderDate;
  const purchaseOrderExpiryDate = order && order.purchaseOrder && order.purchaseOrder.purchaseOrderExpiryDate;

  const hasPODoc = getDefaultFiles(order.documents).length > 0;

  return {
    purchaseOrderNo: poNumber
      ? {
          value: poNumber,
          errors: [],
          touched: false,
          validator: alphaNumericWithSpecialCharactersValidator
        }
      : {
          ...formElement,
          validator: alphaNumericWithSpecialCharactersValidator
        },
    purchaseOrderDate: purchaseOrderDate ? { value: getDate(purchaseOrderDate), errors: [], touched: false } : { ...formElement },
    purchaseOrderExpiryDate: purchaseOrderExpiryDate ? { value: getDate(purchaseOrderExpiryDate), errors: [], touched: false } : { ...formElement },
    purchaseOrderTotalCharges: poAmount
      ? {
          value: poAmount,
          errors: [],
          touched: false,
          validator: numberValidator
        }
      : { ...formElement, validator: numberValidator },
    files: hasPODoc
      ? {
          value: 'success',
          errors: [],
          touched: false
        }
      : { ...formElement }
  };
};

export const getDefaultCheckBoxValue = (order, leadStatus) => {
  const poDetails = order && order.purchaseOrder;

  const hasPODoc = order && order.documents && order.documents.PURCHASE_ORDER && order.documents.PURCHASE_ORDER.PO_DOCUMENT;

  if (poDetails && poDetails.poNumber && poDetails.purchaseOrderDate && poDetails.poAmount && hasPODoc) {
    return true;
  } else {
    return false;
  }
};
